function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-outside-1_2449_821",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 95,
  height: 38,
  fill: "black"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "white",
  width: 95,
  height: 38
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 13C1 6.37258 6.37258 1 13 1H82C88.6274 1 94 6.37258 94 13V24C94 30.6274 88.6274 36 82 36H13C6.37258 36 1 30.6274 1 24V13Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1 13C1 6.37258 6.37258 1 13 1H82C88.6274 1 94 6.37258 94 13V24C94 30.6274 88.6274 36 82 36H13C6.37258 36 1 30.6274 1 24V13Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 13C0 5.8203 5.8203 0 13 0H82C89.1797 0 95 5.8203 95 13H93C93 6.92487 88.0751 2 82 2H13C6.92487 2 2 6.92487 2 13H0ZM95 25C95 32.1797 89.1797 38 82 38H13C5.8203 38 0 32.1797 0 25L2 24C2 29.5228 6.92487 34 13 34H82C88.0751 34 93 29.5228 93 24L95 25ZM13 38C5.8203 38 0 32.1797 0 25V13C0 5.8203 5.8203 0 13 0V2C6.92487 2 2 6.92487 2 13V24C2 29.5228 6.92487 34 13 34V38ZM82 0C89.1797 0 95 5.8203 95 13V25C95 32.1797 89.1797 38 82 38V34C88.0751 34 93 29.5228 93 24V13C93 6.92487 88.0751 2 82 2V0Z",
  fill: "#D26855",
  mask: "url(#path-1-outside-1_2449_821)"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  transform: "translate(17 8)",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M25.901 22.3936C25.901 22.8431 25.5562 23.1833 25.0944 23.1833C24.7804 23.1833 24.528 23.0618 24.2201 22.7763L21.8066 20.5286C21.7758 20.4983 21.7328 20.4861 21.6773 20.4861H20.0396C19.153 20.4861 18.6666 19.9941 18.6666 19.0707V16.9385C18.6666 16.0151 19.153 15.5291 20.0396 15.5291H21.6835C21.7328 15.5291 21.7758 15.5109 21.8128 15.4806L24.2201 13.2511C24.5526 12.9413 24.7804 12.8198 25.0882 12.8198C25.5562 12.8198 25.901 13.1843 25.901 13.6338V22.3936Z",
  fill: "#EC7963"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M31.239 21.9866C31.0419 22.2721 30.691 22.3389 30.4016 22.1627C30.0938 21.9805 30.0568 21.6039 30.2723 21.2698C30.8757 20.3646 31.2328 19.2044 31.2328 17.9955C31.2328 16.7866 30.8819 15.6203 30.2723 14.7212C30.0507 14.3871 30.0938 14.0105 30.4016 13.8282C30.691 13.6521 31.0419 13.7189 31.239 14.0044C32.0086 15.0796 32.4457 16.5193 32.4457 17.9955C32.4457 19.4716 32.0024 20.8992 31.239 21.9866Z",
  fill: "#EC7963"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M28.7885 20.4497C28.5977 20.717 28.2467 20.7777 27.9697 20.6076C27.6618 20.4071 27.6064 20.0487 27.8465 19.6721C28.1605 19.2165 28.3391 18.6212 28.3391 17.9955C28.3391 17.3698 28.1667 16.7684 27.8465 16.3189C27.6003 15.9483 27.6618 15.5838 27.9697 15.3894C28.2467 15.2072 28.5977 15.274 28.7885 15.5352C29.2688 16.1852 29.552 17.0661 29.552 17.9955C29.552 18.9249 29.2688 19.8118 28.7885 20.4497Z",
  fill: "#EC7963"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M57.02 13.352V22.312H55.772V13.352H57.02ZM48.236 11.592L49.564 11.992C49.292 12.968 48.94 13.976 48.556 14.952V26.248H47.164V17.768C46.86 18.28 46.556 18.728 46.236 19.144C46.124 18.792 45.788 17.944 45.548 17.576C46.7 16.088 47.66 13.848 48.236 11.592ZM53.676 17.256H51.612C51.452 17.784 51.26 18.296 51.052 18.776C51.724 19.272 52.46 19.896 52.956 20.36C53.276 19.432 53.532 18.408 53.676 17.256ZM54.044 15.896L54.284 15.864L55.148 16.088C54.636 21.4 52.972 24.52 50.204 26.2C50.028 25.864 49.628 25.32 49.324 25.048C50.572 24.376 51.612 23.272 52.38 21.736C51.916 21.224 51.132 20.552 50.428 19.976C50.22 20.312 50.012 20.632 49.772 20.936C49.628 20.632 49.244 19.976 48.972 19.672C50.092 18.28 50.7 16.136 51.036 13.784H49.724V12.392H55.004V13.784H52.396C52.284 14.504 52.14 15.224 51.98 15.896H54.044ZM58.332 11.688H59.74V24.376C59.74 25.304 59.548 25.72 58.988 25.944C58.444 26.184 57.516 26.232 56.188 26.232C56.108 25.832 55.884 25.144 55.66 24.728C56.684 24.776 57.644 24.76 57.948 24.76C58.22 24.76 58.332 24.664 58.332 24.376V11.688ZM70.46 18.696H67.004V21.864H70.46V18.696ZM71.948 23.208H67.004V24.328H65.564V17.352H71.948V23.208ZM67.34 13.816H76.668C76.668 13.816 76.652 14.376 76.652 14.584C76.412 21.96 76.188 24.616 75.484 25.448C75.068 26.008 74.652 26.184 73.98 26.264C73.372 26.344 72.3 26.312 71.26 26.264C71.244 25.832 71.02 25.16 70.732 24.712C71.884 24.808 72.94 24.808 73.372 24.808C73.708 24.808 73.916 24.744 74.108 24.536C74.652 23.992 74.908 21.464 75.1 15.288H66.636C65.82 16.856 64.86 18.248 63.82 19.288C63.564 19.032 62.908 18.488 62.54 18.248C64.268 16.712 65.692 14.2 66.508 11.592L68.044 11.96C67.836 12.6 67.58 13.224 67.34 13.816Z",
  fill: "#EC7963"
});

function SvgExample(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 38,
    viewBox: "0 0 95 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExample);
export default __webpack_public_path__ + "static/media/example.ed36a0c5.svg";
export { ForwardRef as ReactComponent };